import {Descriptions, Typography} from "antd";
import React from "react";
import {isNil,isString} from "lodash";
import "./EditableInfo.css";
import {Label} from "./Helpers";
import {CloseCircleOutlined} from "@ant-design/icons";

// todo
//  ? support omit & objects as well arrays
//  - ? text returns text are only visible in edit mode
//  - second edit icon next to label for stacked items
//  - edit box width a little too short ?

const empty = value => isNil(value) || (isString(value) && value.trim()==='' );
const clearIcons = [<CloseCircleOutlined />, <CloseCircleOutlined />];
const clearToolTips = ['clear', 'clearing...']

function changed(onChange, oldValue, newValue){
    if (oldValue!==newValue){
        onChange(newValue);
    }
}

export function EditableInfo({title, data, ...props}) {

    return <div {...props} className={'editable-info'}>
        {title && <Typography.Title>{title}</Typography.Title>}
        {data.map(i =>
            <div key={i.label}  >
                <Label>{i.label}</Label>
                <Typography.Text
                    editable={i.onChange ? {onChange: v=>changed(i.onChange,i.value,v)} : false}
                    className={(i.stack && !empty(i.value))?'stacked':'beside'}
                    copyable={i.onClear && i.value ? {
                            onCopy: ()=>changed(i.onClear,i.value,''),
                            icon: clearIcons,
                            tooltips: clearToolTips
                        }
                        : undefined}
                >{i.value}</Typography.Text>
            </div>
        )}
    </div>
}


function EditableDescriptions({data, ...props}) {
    return <Descriptions {...props} className={'editable-descriptions'}>
        {data.map(i =>
            <Descriptions.Item key={i.label} label={i.label}>
                <Typography.Text editable={i.onChange ? {editing: true} : false}>
                    {i.value}
                </Typography.Text>
            </Descriptions.Item>
        )}
    </Descriptions>
}
